<app-control-layout 
    [control]="formCtrl"
    [label]="label"
    [permission]="permission"
    [ignoreLabel]="ignoreLabel"
    [labelBlock]="labelBlock"
    [attr.id] ="idName">
    <div class="radio-box" [formGroup]="formGroup">
        <div *ngFor="let type of source; let i = index" [ngClass]="{'ml-4' : i > 0 }">
            <input #radiobutton type="radio" [disabled]="formCtrl.disabled" [value]="type" (click)="setControl(type[idField])"
                name="customerType" class="mr-2">
            <span>{{ type[fieldDescription] }}</span>
        </div>
        <div class="text-danger" *ngIf="control?.errors?.required && (control?.touched || externalTrigger)">
            {{label}} field is required.
        </div>
    </div>
</app-control-layout>
